import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { FeaturedThisWeekService } from 'src/app/services/featured-this-week.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
  providers: [MessageService]
})

export class AddComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  pagetitle: string;
  statuses: any = [];
  featuredThisWeekForm: FormGroup;
  featuredThisWeekStatus: boolean = true;
  notproduct: boolean = false;
  showUploadedpic: boolean = false;
  uploadedFiles: any[] = [];
  featuredThisWeekImage: any[] = [];
  submitted: boolean = false;
  minYear = environment.minYear;
  yearRange: string;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropDialog: boolean = false;
  selectedFile: File | null = null;
  imageSize = 1000000;
  croppedImageMaxSize = 1000000;
  croppedImageSize = 0;
  croppedImageError: string | null = null;
  scale = 1;
  transform: ImageTransform = {};
  cropApplied = false;
  isApplyingCrop = false;
  isSubmitting = false;
  private acceptedFeaturedFile: File | null = null;
  private previousAcceptedFeaturedFile: File | null = null;
  private previousUploadedFiles: any[] = [];
  private previousFeaturedThisWeekImage: any[] = [];

  constructor(private formBuilder: FormBuilder, private router: Router, private featuredThisWeekService: FeaturedThisWeekService, private messageService: MessageService) { }

  ngOnInit(): void {
    this.yearRange = this.minYear + ":2030";
    this.pagetitle = 'Add Featured this week';
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];
    this.featuredThisWeekForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      status: [true, Validators.required],
      // link: ['', [Validators.required]],
      link: ['', [Validators.required, Validators.pattern('^(https?:\\/\\/)([\\da-z.-]+)\\.([a-z.]{2,6})([\\/\\w .-]*)*\\/?$')]],
      description: ['', [Validators.required]],
      date: [null, [Validators.required]]
    })
  }

  get f() {
    return this.featuredThisWeekForm.controls;
  }

  onStatusSelect(event) {
    if (event) {
      this.featuredThisWeekStatus = event.value;
    }
  }
  
  onFileSelect(event: any) {
    const file = event.files[0];
    if (!file) return;

    this.capturePreviousImage();
    this.cropApplied = false;
    if (file.size > this.imageSize) {
      this.rejectOversizedImage();
      return;
    }

    this.croppedImage = null;
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = file;
    this.isApplyingCrop = false;
    this.resetZoom();
    const fileEvent: any = {
      target: {
        files: [file]
      }
    };
    this.imageChangedEvent = fileEvent;
    this.cropDialog = true;
  }

  get cropDialogTitle(): string {
    return 'Crop & Adjust Featured Image';
  }

  get cropDialogSubtitle(): string {
    return 'Position and scale your image for a 736 x 840 crop';
  }

  get cropPreviewLabel(): string {
    return '736 x 840 px - High Quality JPEG';
  }

  zoomIn() {
    this.scale += 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomOut() {
    if (this.scale > 0.2) {
      this.scale -= 0.1;
      this.transform = {
        ...this.transform,
        scale: this.scale
      };
    }
  }

  resetZoom() {
    this.scale = 1;
    this.transform = {
      ...this.transform,
      scale: 1
    };
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
    this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
      ? 'Cropped image size must not exceed 1 MB.'
      : null;
  }

  onCropImageLoadFailed() {
    this.croppedImage = null;
    this.croppedImageSize = 0;
    this.croppedImageError = 'This image could not be loaded. Please choose a valid image file.';
  }
  
  getBase64SizeBytes(base64: string): number {
    if (!base64) return 0;
    return Math.round(
      (base64.length * (3 / 4)) -
      (base64.split(',')[0].length + 1)
    );
  }

  applyCrop() {
    if (this.isApplyingCrop || this.croppedImageError || !this.croppedImage || !this.selectedFile) return;
    this.isApplyingCrop = true;
    const file = this.base64ToFile(
      this.croppedImage,
      this.getOutputFileName(this.selectedFile.name)
    );
    if (file.size > this.croppedImageMaxSize) {
      this.croppedImageError = 'Cropped image size must not exceed 1 MB.';
      this.isApplyingCrop = false;
      return;
    }

    (file as any).objectURL = this.croppedImage;
    this.uploadedFiles = [file];
    this.featuredThisWeekImage = [{ file: this.croppedImage }];
    this.acceptedFeaturedFile = file;
    this.notproduct = false;
    if (this.fileUpload) {
      this.fileUpload.clear();
      this.fileUpload.files = [file];
    }
    this.cropApplied = true;
    this.cropDialog = false;
  }

  onCropCancel() {
    this.cropApplied = false;
    this.cropDialog = false;
  }

  onDialogHide() {
    if (!this.cropApplied) {
      this.restorePreviousImage();
    }
    this.resetCropState();
  }

  private capturePreviousImage() {
    this.previousUploadedFiles = [...this.uploadedFiles];
    this.previousFeaturedThisWeekImage = [...this.featuredThisWeekImage];
    this.previousAcceptedFeaturedFile = this.acceptedFeaturedFile;
  }

  private restorePreviousImage() {
    this.uploadedFiles = [...this.previousUploadedFiles];
    this.featuredThisWeekImage = [...this.previousFeaturedThisWeekImage];
    this.acceptedFeaturedFile = this.previousAcceptedFeaturedFile;
    if (this.fileUpload) {
      this.fileUpload.clear();
      this.fileUpload.files = this.acceptedFeaturedFile ? [this.acceptedFeaturedFile] : [];
    }
  }

  private resetCropState() {
    this.imageChangedEvent = null;
    this.croppedImage = null;
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = null;
    this.previousUploadedFiles = [];
    this.previousFeaturedThisWeekImage = [];
    this.previousAcceptedFeaturedFile = this.acceptedFeaturedFile;
    this.cropApplied = false;
    this.isApplyingCrop = false;
    this.resetZoom();
  }
  
  rejectOversizedImage() {
    this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image no larger than 1 MB', life: 6000 });
    this.restorePreviousImage();
    this.resetCropState();
  } 

  base64ToFile(data: string, filename: string): File {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  picUploader(event) {
    const files: File[] = event?.files || event;
    if (!files || files.length === 0) return;
    const file = files[0];
    this.uploadedFiles = [file];
    this.acceptedFeaturedFile = file;
    this.notproduct = false;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result != null) {
        this.featuredThisWeekImage = [{ file: reader.result }];
      }
    };
  }

  removeFile(event) {
    this.uploadedFiles = [];
    this.featuredThisWeekImage = [];
    this.acceptedFeaturedFile = null;
  }

  onSubmit() {
    if (this.isSubmitting) {
      return;
    }
    this.submitted = true;
    let addFeaturedThisWeekData = {};
    if (this.featuredThisWeekImage.length === 0) {
      this.notproduct = true;
      return;
    } else {
      this.notproduct = false;
    }

    if (this.featuredThisWeekForm.invalid) {
      return;
    }

    addFeaturedThisWeekData['title'] = this.featuredThisWeekForm.value.title;
    addFeaturedThisWeekData['status'] = this.featuredThisWeekForm.value.status;
    addFeaturedThisWeekData['link'] = this.featuredThisWeekForm.value.link;
    addFeaturedThisWeekData['description'] = this.featuredThisWeekForm.value.description;
    addFeaturedThisWeekData['date'] = moment(this.featuredThisWeekForm.value.date, "DD-MM-YYYY").format("YYYY-MM-DD");
    addFeaturedThisWeekData['photo'] = this.featuredThisWeekImage[0].file;

    addFeaturedThisWeekData = JSON.stringify(addFeaturedThisWeekData, null, 4);
    this.isSubmitting = true;
    this.featuredThisWeekService.addFeaturedThisWeek(addFeaturedThisWeekData).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Featured this week Added Successfully', life: 6000 });
      setTimeout(() => {
        this.router.navigate(['/manage/featured-this-week']);
      }, 2000);
    }, (error) => {
      this.isSubmitting = false;
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: error.error.message, life: 6000 });
    })
  }

  private getOutputFileName(filename: string | undefined): string {
    const baseName = (filename || 'featured-image').replace(/\.[^/.]+$/, '');
    return `${baseName}.jpg`;
  }

  backLink() {
    this.router.navigate(['/manage/featured-this-week']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
